const getThemeFragment = key => value => ({ theme }) => {
  const availableValues = Object.keys(theme[key]);

  if (!availableValues.includes(value)) {
    throw new Error(
      `Invalid theme.${key} property '${value}'. Available values:` +
        `\n - ${availableValues.join("\n - ")}`
    );
  }

  return theme[key][value];
};

export const fontSize = getThemeFragment("fontSizes");

export const color = getThemeFragment("colors");

export const hyphenate = (string, regex = /\s/g) => string.replace(regex, "-");

export const hashParamsBrandId = location =>
  window.btoa(
    JSON.stringify({
      location,
    })
  );

export const capitalizeFirstLetter = s => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};
